import { Sens } from '@mairistem/comptabilite';

const getEvenementLibelle = (libelle: string) =>
	libelle ? [`de l'évènement '${libelle}'`] : [];
const getFinancementTextBySens = (sens: string) =>
	sens === Sens.DEPENSE ? 'du crédit de paiement' : 'de la ressource';

const AUTORISATION_MODAL_ERROR = {
	CODE_REQUIRED: 'Le code est obligatoire',
	COMPOSANT_LIBELLE_REQUIRED: "Le libellé de l'évènement est obligatoire",
	COMPOSANT_MONTANT_REQUIRED: "Le montant de l'évènement est obligatoire",
	ETIQUETTE_REQUIRED: 'La catégorie est obligatoire',
	FINANCEMENT_EXERCICE_INCORRECT: (sens: string, libelle: string) =>
		[
			"L'exercice",
			getFinancementTextBySens(sens),
			getEvenementLibelle(libelle),
			'est incorrect',
		].join(' '),
	FINANCEMENT_EXERCICE_REQUIRED: (sens: string, libelle: string) =>
		[
			"L'exercice",
			getFinancementTextBySens(sens),
			getEvenementLibelle(libelle),
			'est obligatoire',
		].join(' '),
	FINANCEMENT_MONTANT_REQUIRED: (sens: string, year: number, libelle: string) =>
		[
			'Le montant',
			getFinancementTextBySens(sens),
			`'${year}'`,
			getEvenementLibelle(libelle),
			'est obligatoire',
		].join(' '),
	LIBELLE_REQUIRED: 'Le libellé est obligatoire',
	MONTANT_REQUIRED: 'Le montant est obligatoire',
	PRO_IMPUTATION_IMPUTATION_REQUIRED: (
		sens: string,
		year: number,
		libelle: string,
	) =>
		[
			"L'imputation",
			getFinancementTextBySens(sens),
			`'${year}'`,
			getEvenementLibelle(libelle),
			'est obligatoire',
		].join(' '),
	PRO_IMPUTATION_EXERCICE_INEXISTANT: (
		sens: string,
		year: number,
		libelle: string,
	) =>
		[
			'Les imputations',
			getFinancementTextBySens(sens),
			`'${year}'`,
			...getEvenementLibelle(libelle),
			"ne peuvent pas être saisies car l'exercice n'existe pas en comptabilité",
		].join(' '),
	PRO_IMPUTATION_SERVICE_SANS_ESPACE: (
		sens: string,
		year: number,
		anneeExerciceSaisie: number,
		libelle: string,
	) =>
		[
			'Les imputations',
			getFinancementTextBySens(sens),
			`'${year}'`,
			...getEvenementLibelle(libelle),
			"ne peuvent pas être saisies car le service n'est rattaché à aucun espace budgétaire sur l'exercice",
			`'${anneeExerciceSaisie}'`,
		].join(' '),
	TOTAL_MONTANT_EVENEMENT_INCORRECT:
		"Le montant total des évènements est supérieur au montant total de l'autorisation",
	TOTAL_MONTANT_FINANCEMENT_INCORRECT: (sens: string, libelle: string) =>
		[
			'Le montant total des',
			sens === Sens.DEPENSE ? 'crédits de paiement' : 'ressources',
			'est supérieur au montant total de',
			...(libelle ? [`l'évènement '${libelle}'`] : ["l'autorisation"]),
		].join(' '),
	TOTAL_MONTANT_PRO_IMPUTATION_INCORRECT: (
		sens: string,
		year: number,
		libelle: string,
	) =>
		[
			'Le montant total des imputations est supérieur au montant total',
			getFinancementTextBySens(sens),
			`'${year}'`,
			getEvenementLibelle(libelle),
		].join(' '),
} as const;

export default AUTORISATION_MODAL_ERROR;
